import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "./Navbar";

// This would typically come from an API or database
const RECIPES = [
  {
    id: 1,
    title: "Perfect Soft-Boiled Eggs",
    description:
      "Learn how to make the perfect soft-boiled eggs for breakfast or brunch.",
    image:
      "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "perfect-soft-boiled-eggs",
    tags: ["soft-boiled"],
    timerSetting: "6-7 minutes",
    ingredients: [
      "4 large eggs",
      "Water",
      "Salt and pepper to taste",
      "Toast for serving",
    ],
    instructions: [
      "Bring a pot of water to a boil.",
      "Gently lower the eggs into the boiling water.",
      "Set the timer for 6-7 minutes.",
      "While the eggs are cooking, prepare your toast.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 1 minute.",
      "Peel the eggs carefully and serve with toast, salt, and pepper.",
    ],
  },
  {
    id: 2,
    title: "Jammy Eggs for Ramen",
    description:
      "Create the perfect jammy eggs to top your favorite ramen bowl.",
    image:
      "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "jammy-eggs-for-ramen",
    tags: ["runny-yolks"],
    timerSetting: "6 minutes",
    ingredients: [
      "4 large eggs",
      "Water",
      "Soy sauce",
      "Mirin (optional)",
      "Ramen noodles and broth",
    ],
    instructions: [
      "Bring a pot of water to a boil.",
      "Gently lower the eggs into the boiling water.",
      "Set the timer for 6 minutes.",
      "While the eggs are cooking, prepare your ramen according to package instructions.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 1 minute.",
      "Peel the eggs carefully and slice in half.",
      "Place the eggs on top of your ramen and serve.",
    ],
  },
  {
    id: 3,
    title: "Hard-Boiled Eggs for Meal Prep",
    description:
      "Make a batch of hard-boiled eggs for your weekly meal prep routine.",
    image:
      "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "hard-boiled-eggs-meal-prep",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: ["12 large eggs", "Water", "Salt (optional)"],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and store in an airtight container in the refrigerator for up to 5 days.",
    ],
  },
  {
    id: 4,
    title: "Dippy Eggs with Soldiers",
    description:
      "Classic British breakfast with perfectly runny eggs and toast soldiers.",
    image:
      "https://images.unsplash.com/photo-1518568814500-bf0f8d125f46?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "dippy-eggs-with-soldiers",
    tags: ["runny-yolks"],
    timerSetting: "3 minutes",
    ingredients: [
      "2 large eggs",
      "Water",
      "2 slices of bread",
      "Butter",
      "Salt and pepper to taste",
    ],
    instructions: [
      "Bring a pot of water to a boil.",
      "Gently lower the eggs into the boiling water.",
      "Set the timer for 3 minutes.",
      "While the eggs are cooking, toast the bread and cut into soldiers (thin strips).",
      "When the timer goes off, immediately remove the eggs and place them in egg cups.",
      "Serve with the toast soldiers, salt, and pepper.",
    ],
  },
  {
    id: 5,
    title: "Classic Deviled Eggs",
    description:
      "A party favorite with creamy, tangy filling and a sprinkle of paprika.",
    image:
      "https://images.unsplash.com/photo-1580013759032-c96505e24c1f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "classic-deviled-eggs",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: [
      "12 large eggs",
      "1/4 cup mayonnaise",
      "1 teaspoon Dijon mustard",
      "1 teaspoon white vinegar",
      "Salt and pepper to taste",
      "Paprika for garnish",
    ],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and cut in half lengthwise.",
      "Remove the yolks and place in a bowl.",
      "Mash the yolks with a fork and mix with mayonnaise, mustard, vinegar, salt, and pepper.",
      "Spoon the mixture back into the egg whites.",
      "Sprinkle with paprika and serve.",
    ],
  },
  {
    id: 6,
    title: "Japanese Egg Sando",
    description:
      "Creamy Japanese-style egg salad sandwich with a perfect balance of flavors.",
    image:
      "https://images.unsplash.com/photo-1528735602780-2552fd46c7af?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "japanese-egg-sando",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: [
      "4 large eggs",
      "4 slices of soft white bread",
      "2 tablespoons mayonnaise",
      "1 teaspoon Dijon mustard",
      "1/2 teaspoon sugar",
      "Salt and pepper to taste",
      "Butter for spreading",
    ],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and mash them with a fork.",
      "Mix with mayonnaise, mustard, sugar, salt, and pepper.",
      "Butter the bread and spread the egg mixture on two slices.",
      "Top with the remaining slices and cut off the crusts.",
      "Cut into triangles and serve.",
    ],
  },
  {
    id: 7,
    title: "Perfect Egg Salad Sandwich",
    description:
      "A classic sandwich with creamy egg salad, perfect for picnics and lunches.",
    image:
      "https://images.unsplash.com/photo-1528735602780-2552fd46c7af?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "perfect-egg-salad-sandwich",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: [
      "6 large eggs",
      "4 slices of bread",
      "1/4 cup mayonnaise",
      "1 teaspoon Dijon mustard",
      "1/4 cup finely chopped celery",
      "1/4 cup finely chopped red onion",
      "Salt and pepper to taste",
      "Lettuce leaves for serving",
    ],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and chop them into small pieces.",
      "Mix with mayonnaise, mustard, celery, red onion, salt, and pepper.",
      "Spread the egg salad on two slices of bread.",
      "Top with lettuce leaves and the remaining slices of bread.",
      "Cut diagonally and serve.",
    ],
  },
  {
    id: 8,
    title: "Cobb Salad with Hard-Boiled Eggs",
    description:
      "A hearty salad with hard-boiled eggs, bacon, avocado, and blue cheese.",
    image:
      "https://images.unsplash.com/photo-1540420773420-3366772f4999?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "cobb-salad-with-hard-boiled-eggs",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: [
      "4 large eggs",
      "6 cups mixed salad greens",
      "2 chicken breasts, grilled and sliced",
      "6 slices bacon, cooked and crumbled",
      "1 avocado, sliced",
      "1/2 cup blue cheese, crumbled",
      "1/2 cup cherry tomatoes, halved",
      "1/4 cup red wine vinegar",
      "1/4 cup olive oil",
      "1 teaspoon Dijon mustard",
      "Salt and pepper to taste",
    ],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and slice them.",
      "Arrange the salad greens on a large platter.",
      "Top with rows of chicken, bacon, avocado, blue cheese, tomatoes, and egg slices.",
      "Whisk together the vinegar, oil, mustard, salt, and pepper to make the dressing.",
      "Drizzle the dressing over the salad and serve.",
    ],
  },
  {
    id: 9,
    title: "Scotch Eggs",
    description:
      "A British pub favorite with hard-boiled eggs wrapped in seasoned sausage.",
    image:
      "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    slug: "scotch-eggs",
    tags: ["hard-boiled"],
    timerSetting: "10 minutes",
    ingredients: [
      "6 large eggs",
      "1 pound bulk breakfast sausage",
      "1/2 cup all-purpose flour",
      "2 eggs, beaten",
      "1 cup breadcrumbs",
      "Vegetable oil for frying",
      "Salt and pepper to taste",
      "Mustard for serving",
    ],
    instructions: [
      "Place the eggs in a single layer in a large pot.",
      "Cover with cold water by about 1 inch.",
      "Bring to a boil over high heat.",
      "Once boiling, set the timer for 10 minutes.",
      "When the timer goes off, immediately remove the eggs and place them in an ice bath for 5 minutes.",
      "Peel the eggs and set aside.",
      "Divide the sausage into 6 equal portions.",
      "Flatten each portion into a patty and wrap around an egg, making sure to completely cover the egg.",
      "Roll each sausage-wrapped egg in flour, then dip in beaten eggs, and finally coat with breadcrumbs.",
      "Heat oil in a deep fryer or large pot to 350°F.",
      "Fry the scotch eggs for 5-7 minutes, or until golden brown and cooked through.",
      "Drain on paper towels and serve with mustard.",
    ],
  },
];

const RecipeDetail = () => {
  const { slug } = useParams();
  const recipe = RECIPES.find((r) => r.slug === slug);

  if (!recipe) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">
              Recipe not found
            </h1>
            <Link
              to="/recipes"
              className="mt-4 inline-block text-orange-500 hover:text-orange-600"
            >
              Back to Recipes
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const formatTag = (tag) => {
    return tag
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="max-w-4xl mx-auto">
          <header className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {recipe.title}
            </h1>
            <div className="flex flex-wrap justify-center gap-2 mb-4">
              {recipe.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-gray-200 transition-colors duration-200"
                >
                  {formatTag(tag)}
                </span>
              ))}
            </div>
            <div className="inline-flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-lg mb-6">
              <span className="font-semibold text-orange-600">
                Timer Setting:
              </span>
              <span className="font-bold text-orange-700">
                {recipe.timerSetting}
              </span>
            </div>
          </header>

          <div className="mb-8">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden shadow-lg">
              <img
                src={recipe.image}
                alt={recipe.title}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <p className="text-xl text-gray-600 text-center mb-12">
            {recipe.description}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="md:col-span-1 bg-white p-6 rounded-xl shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Ingredients
              </h2>
              <ul className="space-y-2">
                {recipe.ingredients.map((ingredient, index) => (
                  <li
                    key={index}
                    className="py-2 border-b border-gray-100 last:border-0 text-gray-600"
                  >
                    {ingredient}
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2 bg-white p-6 rounded-xl shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Instructions
              </h2>
              <ol className="space-y-4">
                {recipe.instructions.map((instruction, index) => (
                  <li key={index} className="text-gray-600 leading-relaxed">
                    {instruction}
                  </li>
                ))}
              </ol>
            </div>
          </div>

          <div className="flex justify-center gap-4">
            <Link
              to="/timer"
              className="px-6 py-3 bg-orange-500 text-white rounded-full font-semibold hover:bg-orange-600 transition-colors duration-200"
            >
              Start Timer
            </Link>
            <Link
              to="/recipes"
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-full font-semibold hover:bg-gray-200 transition-colors duration-200"
            >
              Back to Recipes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipeDetail;
